import Vue from 'vue'
import Router from 'vue-router'
import header from '../main_components'
import secureAccess from '../components/secureAccess/secureAccess'
import resumeContract from '../components/resumeContract/resumeContract'

Vue.use(Router)
Vue.use(header)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/:id_container/:id_notification',
            name: 'secureAccess',
            component: secureAccess,
            props: true
        },
        {
            path: '/resume',
            name: 'resumeContract',
            component: resumeContract,
            props: true
        },
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js